import React, { useState, useEffect } from 'react';
import './OwndaysTips.scss';
import { ARTICLES } from '../../views/Articles/Articles';

const OwndaysTips = () => {
  const [articlesToShow, setArticlesToShow] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setArticlesToShow(4);
      } else {
        setArticlesToShow(3);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="od-home__tips">
      <div className="od-home__tips-container">
        <div className="od-home__tips-title">
          <h2>
            OWNDAYS <br />
            Tips
          </h2>
          <a href="/sg/en/articles">
            See all Tips{' '}
            <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDYgMTEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xXzE2NzUpIj4KPHBhdGggZD0iTTYgNS41TDAuNzUyMzcxIDBMMCAwLjc4ODU1NEw0LjQ5NTI2IDUuNUwwIDEwLjIxMTRMMC43NTIzNzEgMTFMNS4yNDc2MyA2LjI4ODU1TDYgNS41WiIgZmlsbD0iIzAwOTRDOCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzFfMTY3NSI+CjxyZWN0IHdpZHRoPSI2IiBoZWlnaHQ9IjExIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=" />
          </a>
        </div>
        <div className="od-home__tips-content">
          <ul className="od-home__tips-list">
            {ARTICLES?.slice(0, articlesToShow).map(article => (
              <li key={article.permalink}>
                <a href={`/sg/en/articles/${article?.permalink}`}>
                  <img src={article?.img} alt={article?.title} loading="lazy" />
                  <h3>{article?.title}</h3>
                </a>
              </li>
            ))}
          </ul>
          <div className="od-home__tips-actions">
            <a href="/sg/en/articles" className="button">
              See all Tips
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwndaysTips;
